import Vue from 'vue/dist/vue.esm.js';

Vue.component('add-to-cart-product-template', {
    template: `#add-to-cart-product-template`,
    delimiters: ['[[', ']]'],
    props: {
        initialCartRow: {
            required: false,
            type: Object
        },
        removeRowUrl: {
            required: true,
            type: String,
        },
        productUrl: {
            required: true,
            type: String
        },
        productIsPossibleAddToCart: {
            required: true,
            type: Boolean
        },
        productDefaultVariantId: {
            required: true,
            type: Number
        },
        productId: {
            required: true,
            type: Number
        },
        productName: {
            required: true,
            type: String
        }

    },

    data() {
        return {
            cartRow: this.initialCartRow,
            quantity: this.initialCartRow?.quantity || 0,
            isPossibleAddToCart: this.productIsPossibleAddToCart,
            context: null
        }
    },

    methods: {
        decrementVariantQuantity() {
            this.quantity = parseInt(this.quantity) - 1;
            if (this.quantity === 0) {
                EventManager.fire('remove-row-event', {id: this.cartRow.id, removeItemUrl: this.removeRowUrl});
            } else {
                EventManager.fire('decrement-event', this.cartRow);
            }
            if (this.context) {
                this.gtmContext()
            }
        },

        incrementQuantity() {
            this.quantity = parseInt(this.quantity) + 1;
            EventManager.fire('increment-event', {
                variantId: this.productDefaultVariantId,
                name: this.productName
            });
            if (this.context) {
                this.gtmContext()
            }
        },

        updateQuantity(cart) {
            cart.rows.forEach(row => {
                if (row.variantId == this.productDefaultVariantId) {
                    this.quantity = row.quantity;
                    this.cartRow = row;
                    this.isPossibleAddToCart = row.isPossibleAddToCart;
                }
            });
        },
        resetQuantity() {
            this.quantity = 0;
            this.isPossibleAddToCart = this.productIsPossibleAddToCart;
        },

        gtmContext() {
            EventManager.fire(`add-to-cart-gtm-context`, {
                context: this.context,
                productId: this.productId,
            });
        }
    },

    mounted() {
        EventManager.listen(`update-quantity`, this.updateQuantity);
        EventManager.listen(`remove-row-${this.productDefaultVariantId}`, this.resetQuantity);

        this.context = this.$el.closest(`.product-item`).getAttribute('data-list')
    },
});
